import { useMutation } from '@apollo/client/react';
import { useSetAtom } from 'jotai';
import { useCallback, useState } from 'react';

import { Fields } from '~/components/partials/GuestPatientForm/types';
import { UpdateDirectVisitorDocument } from '~/graphql/generated/graphql';
import { useScrollToTop } from '~/hooks/use-scroll-to-top';
import { patientDetailDialogProfileState } from '~/state/partials/patient_detail_dialog/atoms';

export const useUpdateGuestPatient = () => {
  const [containerRef, scrollToTop] = useScrollToTop<HTMLDivElement>();

  const [isUpdating, setIsUpdating] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const setState = useSetAtom(patientDetailDialogProfileState);

  const [updateGuestPatient] = useMutation(UpdateDirectVisitorDocument);

  const update = useCallback(
    async (values: Fields, guestPatientId: string) => {
      setIsUpdating(true);
      setError(null);

      const sex = values.sex === 'male' ? 'male' : values.sex === 'female' ? 'female' : 'unknown';

      try {
        await updateGuestPatient({
          variables: {
            input: {
              ...values,
              directVisitorId: guestPatientId,
              sex,
            },
          },
        });
        setState((_state) => ({ ..._state, type: null }));
      } catch (error) {
        setError(error?.message || 'エラーが発生しました');
        scrollToTop();
      }
      setIsUpdating(false);
    },
    [updateGuestPatient, scrollToTop, setState],
  );

  return {
    isUpdating,
    error,
    containerRef,
    update,
  };
};
